import { Checkbox } from '@heroui/react';
import { CustomInput } from '@/shared/ui/Fields';

export type ScormAttemptsMode = 'unlimited' | 'limited';
export type ScormResumeBehavior = 'new' | 'resume';
export type ScormCompletionRule = 'completed' | 'score';

interface ScormSettingsFieldsProps {
  attempts: ScormAttemptsMode;
  onAttemptsChange: (value: ScormAttemptsMode) => void;
  attemptsCount: number;
  onAttemptsCountChange: (value: number) => void;
  resumeBehavior: ScormResumeBehavior;
  onResumeBehaviorChange: (value: ScormResumeBehavior) => void;
  completionRule: ScormCompletionRule;
  onCompletionRuleChange: (value: ScormCompletionRule) => void;
  completionScorePercent: number;
  onCompletionScorePercentChange: (value: number) => void;
  isDisabled?: boolean;
}

export const ScormSettingsFields = ({
  // attempts,
  // onAttemptsChange,
  // attemptsCount,
  // onAttemptsCountChange,
  // resumeBehavior,
  // onResumeBehaviorChange,
  completionRule,
  onCompletionRuleChange,
  completionScorePercent,
  onCompletionScorePercentChange,
  isDisabled = false,
}: ScormSettingsFieldsProps) => (
  <div className={isDisabled ? 'opacity-50 pointer-events-none' : undefined}>
    <h3 className="text-sm font-medium text-black-headline mb-3">SCORM settings</h3>
    <div className="flex flex-col gap-4">
      {/*<div>*/}
      {/*  <p className="text-sm text-black-headline mb-2">Attempts</p>*/}
      {/*  <RadioGroup*/}
      {/*    value={attempts}*/}
      {/*    onValueChange={(v) => onAttemptsChange(v as ScormAttemptsMode)}*/}
      {/*    isDisabled={isDisabled}*/}
      {/*    classNames={{ wrapper: 'flex flex-row gap-4' }}*/}
      {/*  >*/}
      {/*    <Radio value="unlimited" classNames={{ label: 'text-sm !text-black-headline' }}>*/}
      {/*      Unlimited*/}
      {/*    </Radio>*/}
      {/*    <div className="flex items-center gap-2">*/}
      {/*      <Radio value="limited" classNames={{ label: 'text-sm !text-black-headline' }}>*/}
      {/*        1*/}
      {/*      </Radio>*/}
      {/*      {attempts === 'limited' && (*/}
      {/*        <CustomInput*/}
      {/*          type="number"*/}
      {/*          min={1}*/}
      {/*          aria-label="Number of attempts"*/}
      {/*          isDisabled={isDisabled}*/}
      {/*          value={String(attemptsCount)}*/}
      {/*          onValueChange={(v) => onAttemptsCountChange(Math.max(1, parseInt(v, 10) || 1))}*/}
      {/*          className="w-20"*/}
      {/*        />*/}
      {/*      )}*/}
      {/*    </div>*/}
      {/*  </RadioGroup>*/}
      {/*</div>*/}
      {/*<div>*/}
      {/*  <p className="text-sm text-black-headline mb-2">Resume behavior</p>*/}
      {/*  <RadioGroup*/}
      {/*    value={resumeBehavior}*/}
      {/*    onValueChange={(v) => onResumeBehaviorChange(v as ScormResumeBehavior)}*/}
      {/*    isDisabled={isDisabled}*/}
      {/*    classNames={{ wrapper: 'flex flex-row gap-4' }}*/}
      {/*  >*/}
      {/*    <Radio value="new" classNames={{ label: 'text-sm !text-black-headline' }}>*/}
      {/*      Start new attempt*/}
      {/*    </Radio>*/}
      {/*    <Radio value="resume" classNames={{ label: 'text-sm !text-black-headline' }}>*/}
      {/*      Resume last attempt*/}
      {/*    </Radio>*/}
      {/*  </RadioGroup>*/}
      {/*</div>*/}
      <div className="flex items-center gap-2">
        <Checkbox
          isSelected={completionRule === 'score'}
          isDisabled={isDisabled}
          onValueChange={(selected) => onCompletionRuleChange(selected ? 'score' : 'completed')}
          classNames={{
            base: 'w-fit',
            label: 'text-sm !text-black-headline',
          }}
        >
          Passed when score ≥ X%
        </Checkbox>
        {completionRule === 'score' && (
          <CustomInput
            type="number"
            min={0}
            max={100}
            aria-label="Passing score percent"
            isDisabled={isDisabled}
            value={String(completionScorePercent)}
            onValueChange={(v) =>
              onCompletionScorePercentChange(Math.min(100, Math.max(0, parseInt(v, 10) || 0)))
            }
            className="w-20"
          />
        )}
      </div>
    </div>
  </div>
);
